import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import $ from 'jquery';
import styled from 'styled-components';
import IntlObject from '../Common/IntlObject';
import { useBuilder } from '../../contexts/BuilderContext';

const LeftFooterMenuContainer = styled.section`
  font-size: 14px;
  color: #000;
  line-height: 1.5;
  box-sizing: border-box;
  position: fixed;
  width: 70px;
  height: 320px;
  left: 0;
  top: 220px;
  z-index: 1000;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  opacity: ${props => props.$isHidden ? 0 : 1};
  visibility: ${props => props.$isHidden ? 'hidden' : 'visible'};
  pointer-events: ${props => props.$isHidden ? 'none' : 'auto'};

  & > ul {
    margin: 0;
    padding: 0;
    list-style: none;
    display: block;
    width: 100%;
    border-radius: 0 6px 6px 0;
    overflow: hidden;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.4);
  }
  & > ul > li {
    -webkit-text-size-adjust: 100%;
    letter-spacing: -0.5px;
    font-size: 14px;
    color: #000;
    line-height: 1.5;
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    list-style: none;
    display: block;
    width: 100%;
    height: 80px;
  }
  & > ul > li > a {
    background: var(--color-primary);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    box-sizing: border-box;
    color: var(--color-text-light);
    transition: all 0.3s;
    height: 100%;
    font-size: 10px;
    text-align: center;
    margin: 0 auto;
    padding: 5px;
    text-decoration: none;
  }
  & > ul > li > a:hover {
    background: var(--color-primary-hover);
  }
  & > ul > li.lf_tel > a > p {
    width: 40px;
    height: 40px;
    background: url('https://i.ibb.co/7RNX1LK/icon-lf-tel.png') center/contain no-repeat;
    margin: 0;
    flex-shrink: 0;
  }
  & > ul > li.lf_email > a > p {
    width: 40px;
    height: 40px;
    background: url('https://i.ibb.co/VW20Vy4/icon-lf-email.png') center/contain no-repeat;
    margin: 0;
    flex-shrink: 0;
  }
  & > ul > li.lf_kakao > a > p {
    width: 40px;
    height: 40px;
    background: url('https://i.ibb.co/tJwsRHq/icon-lf-kakao.png') center/contain no-repeat;
    margin: 0;
    flex-shrink: 0;
  }
  & > ul > li.lf_blog > a > p {
    width: 40px;
    height: 40px;
    background: url('https://i.ibb.co/7RNX1LK/icon-lf-tel.png') center/contain no-repeat;
    margin: 0;
    flex-shrink: 0;
  }
  & > ul > li.lf_contact > a > p {
    width: 40px;
    height: 40px;
    background: url('https://i.ibb.co/WyTZcm4/icon-lf-contact.png') center/contain no-repeat;
    margin: 0;
    flex-shrink: 0;
  }
  & > ul > li.lf_contact > a {
    border: none;
  }
  & > ul > li.lf_tel:hover > ul {
    display: block;
    z-index: 99;
  }
  & > ul > li.lf_tel > ul {
    position: absolute;
    width: 200px;
    height: 100px;
    background: #fff;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.4);
    border-radius: 0 8px 8px 8px;
    overflow: hidden;
    top: 0px;
    left: 70px;
    display: none;
  }
  & > ul > li.lf_tel > ul > li.lf_tel_li1 {
    position: absolute;
    top: 10px;
    right: 15px;
    font-size: 11px;
    color: #e80032;
  }
  & > ul > li.lf_tel > ul > li.lf_tel_li2 > p {
    display: block;
    width: 26px;
    height: 26px;
    background: url('http://www.mobiwebi.com/assets/img/web/icon_side_tel.png') 0 0;
    position: absolute;
    top: 35px;
    left: 15px;
  }
  & > ul > li.lf_tel > ul > li.lf_tel_li2 > span {
    color: #2e2f36;
    font-weight: 800;
    font-size: 22px;
    position: absolute;
    top: 31px;
    left: 45px;
  }
  & > ul > li.lf_tel > ul > li.lf_tel_li3 {
    font-size: 12px;
    color: #6f7075;
    position: absolute;
    bottom: 15px;
    right: 15px;
  }
  & > ul > li.lf_email:hover > ul {
    display: block;
    z-index: 99;
  }
  & > ul > li.lf_email > ul {
    position: absolute;
    min-width: 350px;
    height: 85px;
    background: #fff;
    border-radius: 0 8px 8px 8px;
    overflow: hidden;
    top: 80px;
    left: 70px;
    display: none;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.4);
  }
  & > ul > li.lf_email > ul > li.lf_email_li1 {
    position: absolute;
    top: 10px;
    right: 15px;
    font-size: 11px;
    color: #e80032;
  }
  & > ul > li.lf_email > ul > li.lf_email_li2 > p {
    display: block;
    width: 26px;
    height: 26px;
    background: url('http://www.mobiwebi.com/assets/img/web/icon_side_email.png') 0 0;
    position: absolute;
    top: 35px;
    left: 15px;
  }
  & > ul > li.lf_email > ul > li.lf_email_li2 > span {
    color: #2e2f36;
    font-weight: 700;
    font-size: 15px;
    position: absolute;
    top: 36px;
    left: 50px;
  }
`;

const LeftFooterMenuType01 = ({
  containerClass = '',
  phone,
  phoneAvailable,
  email,
  kakao,
  blog,
  googleFormLink,
}) => {
  const intl = useIntl();
  const builderContext = useBuilder();
  const isSidebarOpen = builderContext?.isSidebarOpen || false;

  useEffect(() => {
    const currentTop = parseInt($('#left-fixed-menu').css('top')) || 220;
    const handleScroll = () => {
      $('#left-fixed-menu')
        .stop()
        .animate({ top: currentTop + 'px' }, 500);
    };

    $(window).on('scroll', handleScroll);

    return () => {
      $(window).off('scroll', handleScroll);
    };
  }, []);

  return (
    <LeftFooterMenuContainer
      id="left-fixed-menu"
      className={containerClass}
      $isHidden={isSidebarOpen}
    >
      <ul>
        {phone && (
          <li className="fw-normal lf_tel">
            <a href="#">
              <p className="my-0"></p>
              <IntlObject keycode="menu.phone" returnType="span" />
            </a>
            <ul>
              <li className="lf_tel_li1">
                <IntlObject keycode="menu.phone.label" returnType="span" />
              </li>
              <li className="lf_tel_li2">
                <p className="my-0"></p>
                <span>{phone}</span>
              </li>
              <li className="lf_tel_li3">{phoneAvailable}</li>
            </ul>
          </li>
        )}
        {email && (
          <li className="fw-normal lf_email">
            <a href={`mailto:${email}`}>
              <p className="my-0"></p>
              <IntlObject keycode="menu.email" returnType="span" />
            </a>
            <ul>
              <li className="lf_email_li1">
                <IntlObject keycode="menu.email" returnType="span" />
              </li>
              <li className="lf_email_li2">
                <p className="my-0"></p>
                <span>{email}</span>
              </li>
            </ul>
          </li>
        )}

        {kakao && (
          <li className="fw-normal lf_kakao">
            <a href={kakao} target="_blank" rel="noreferrer">
              <p className="my-0"></p>
              <IntlObject keycode="menu.kakao" returnType="span" />
            </a>
          </li>
        )}

        {blog && (
          <li className="fw-normal lf_blog">
            <a href={blog} target="_blank" rel="noreferrer">
              <p className="my-0"></p>
              <IntlObject keycode="menu.blog" returnType="span" />
            </a>
          </li>
        )}

        {googleFormLink && (
          <li className="fw-normal lf_contact">
            <a
              href={googleFormLink}
              target="_blank"
              rel="noreferrer"
            >
              <p className="my-0"></p>
              <IntlObject keycode="menu.form" returnType="span" />
            </a>
          </li>
        )}
      </ul>
    </LeftFooterMenuContainer>
  );
};

LeftFooterMenuType01.propTypes = {
  containerClass: PropTypes.string,
  backgroundColor: PropTypes.string,
  phone: PropTypes.string,
  phoneAvailable: PropTypes.string,
  email: PropTypes.string,
  kakao: PropTypes.string,
  blog: PropTypes.string,
  googleFormLink: PropTypes.string,
};

export default LeftFooterMenuType01;
